import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Settings2 } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { platformAdminNavItems } from "@/components/pages/platform-admin/platformAdminNavItems";
import { useSidebarParentMenu } from "@/hooks/useSidebarParentMenu";

export function AdminMenu() {
  const { isExpanded, setIsExpanded, expandFromIcon } = useSidebarParentMenu(false);

  return (
    <>
      <Separator />
      <SidebarGroup className="pt-0">
        <SidebarMenu>
          <Collapsible asChild open={isExpanded} onOpenChange={setIsExpanded} className="group/collapsible">
            <SidebarMenuItem>
              <CollapsibleTrigger asChild>
                <SidebarMenuButton tooltip="Admin" onClick={expandFromIcon}>
                  <Settings2 size={16} />
                  <span>Admin</span>
                  <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                </SidebarMenuButton>
              </CollapsibleTrigger>
              <CollapsibleContent>
                <SidebarMenuSub>
                  {platformAdminNavItems.map((item) => {
                    const Icon = item.icon;
                    return (
                      <SidebarMenuSubItem key={item.path}>
                        <SidebarMenuSubButton asChild>
                          <Link to={item.path}>
                            <Icon className="h-4 w-4" />
                            <span>{item.label}</span>
                          </Link>
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    );
                  })}
                </SidebarMenuSub>
              </CollapsibleContent>
            </SidebarMenuItem>
          </Collapsible>
        </SidebarMenu>
      </SidebarGroup>
    </>
  );
}
